import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/font/stylesheet.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ClinicProvider from "./Provider/ClinicProvider/ClinicProvider";
import DoctorProvider from "./Provider/DoctorProvider/DoctorProvider";
import SearchProvider from "./Provider/SearchProvider/SearchProvider";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
    <SearchProvider>
      <DoctorProvider>
        <ClinicProvider>
          <App />
        </ClinicProvider>
      </DoctorProvider>
    </SearchProvider>
  // </React.StrictMode>
);

// Suppress benign browser ResizeObserver loop notification in dev mode
window.addEventListener("error", (e) => {
  if (
    e.message === "ResizeObserver loop completed with undelivered notifications." ||
    e.message === "ResizeObserver loop limit exceeded" ||
    (typeof e.message === "string" && e.message.includes("ResizeObserver"))
  ) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

reportWebVitals();
